<template>
    <div :class="isLoading ? 'is-loading' : ''">

        <!-- filters -->
        <aside class="d-print-none">
            <!-- types -->
            <ul class="nav nav-pills flex-nowrap flex-md-wrap gap-3 overflow-auto overflow-md-visible pt-2 pb-3 mb-4 px-2 px-md-0">
                <li class="nav-item">
                    <button :class="['nav-link shadow fs-7 px-4 py-2 text-nowrap', filters.type === '' ? 'active' : '']" @click="selectType('')">{{ translate('All') }}</button>
                </li>
                <li class="nav-item" v-for="type in types" :key="type.id">
                    <button :class="['nav-link shadow fs-7 px-4 py-2 text-nowrap', filters.type === type.id ? 'active' : '']" @click="selectType(type.id)">{{ type.title }}</button>
                </li>
            </ul>
        </aside>

        <!-- list -->
        <div data-pagination-change-scroll-to>

            <p v-if="!displayedItems.length && !isLoading" class="text-center mb-4">
                {{ translate('No items available') }}
            </p>

            <article v-for="article in displayedItems" :key="article.id" class="link-list-item mb-3">
                <a :href="article.link" class="stretched-link"></a>
                <div class="d-flex">
                    <div class="link-list-item--image position-relative rounded-1 overflow-hidden">
                        <img :src="getArticleImage(article.image)" :alt="article.heading" class="img-fluid">
                        <!-- badge -->
                        <div v-if="article.tag" :class="[getTagDetails(article.tag).bgcolor, 'badge w-100 text-uppercase letter-spacing-1 position-absolute bottom-0 start-0']">
                            <span>
                                {{ getTagDetails(article.tag).text }}
                            </span>
                        </div>
                    </div>
                    <div class="min-w-0 flex-grow-1 px-4 py-3">
                        <p class="text-secondary fw-semibold">
                            <small class="text-nowrap">
                                {{ article.date }}
                            </small>
                        </p>
                        <h3 class="text-truncate h6 my-2">
                            {{ article.heading }}
                        </h3>
                        <p class="text-truncate-lines-3">
                            {{ article.perex }}
                        </p>
                    </div>
                    <div class="flex-shrink-0 d-none d-md-flex align-items-center">
                        <div class="post-arrow">
                            <svg class="icon-post-arrow">
                                <use xlink:href="#icon-chevron-right"></use>
                            </svg>
                        </div>
                    </div>
                </div>
            </article>

        </div>

        <div class="mt-5 d-print-none">
            <Pagination 
                :items-count="filteredItems.length"
                v-model:current-page="pagination.currentPage" 
                v-model:per-page="pagination.perPage"
            />
        </div>

    </div>
</template>

<script>
import getTagDetails from '@/scripts/helpers/getTagDetails';
import { paginate } from '@/scripts/helpers/pagination';
import { translate } from '@/scripts/mixins/translations';
import Pagination from '@/components/pagination/Pagination.vue';
import { watchFilters } from '@/scripts/mixins/filters';

export default {
    components: {
        Pagination
    },
    mixins: [
        watchFilters(),
        translate
    ],
    data(){
        return {
            isLoading: false,
            filters: {
                type: Number(new URL(window.location).searchParams.get('type')) || '',
            },
            pagination: {
                currentPage: 1,
                perPage: parseInt(localStorage.getItem('list-per-page')) || 10
            },
            types: [],
            events: []
        }
    },
    methods: {
        getTagDetails: getTagDetails,
        getArticleImage(url){
            if ( url.length )
            {
                return url;
            }

            return '/client-assets/public/images/tc-placeholder.svg';
        },
        selectType(id){

            if ( !id || !this.types.find(type => type.id === id) )
            {
                this.filters.type = '';
            }
            else
            {
                this.filters.type = id;
            }

        },
        loadEvents(){
            this.isLoading = true;

            axios.get(`events/archive`)
            .then(response => {
                const { data } = response;

                this.types = data.types;
                this.events = data.events;
            })
            .finally(() => {
                this.isLoading = false;
            });

        }
    },
    computed: {
        filteredItems(){
            let list = this.events;

            if ( this.filters.type ) 
            {
                list = list.filter(article => {
                    return article.type === this.filters.type;
                });
            }

            return list;
        },
        displayedItems(){
            return paginate(this.filteredItems, this.pagination.currentPage, this.pagination.perPage);
        }
    },
    mounted(){
        this.loadEvents();
    }
}
</script>